<template>
    <a href="#top" class="stickyPfeil">
        <i class="fas fa-angle-double-up"></i>
      </a>
</template>